module.exports = __webpack_public_path__ + "static/media/ARF-0003_big.4e0c2a59.png";